import React from 'react'

const PlayButton = () => {
  return (
    <span className="play-svg-wrapper">
      <svg viewBox="0 0 129 160">
        <path
          d="M126.901 82.496c2.343-1.462 2.338-3.836 0-5.295L4.243.659C1.9-.803 0 .248 0 3.01v153.675c0 2.76 1.905 3.81 4.243 2.352l122.658-76.542z"
          fillRule="evenodd"
        />
      </svg>
    </span>
  )
}
export default PlayButton
